// react
import React, { Component } from "react";

// third-party
import classNames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import StroykaSlick from "../shared/StroykaSlick";
import ReactPlayer from 'react-player'

// application
import departmentsAria from "../../services/departmentsArea";
import languages from "../../i18n";
import { useWindowSize } from "../../services/utils";

export const SlickArrowLeft = ({ className, style, onClick }) => {
    const windowSize = useWindowSize()
    return (
        <div
            className={className}
            style={{ ...style, display: windowSize.width < 576 ? "none" : "block" }}
            onClick={onClick}
        />
    );
}
export const SlickArrowRight = ({ className, style, onClick }) => {
    const windowSize = useWindowSize()
    return (
        <div
            className={className}
            style={{ ...style, display: windowSize.width < 576 ? "none" : "block" }}
            onClick={onClick}
        />
    );
}

const slickSettings = {
    infinite: true,
    autoplay: false,
    speed: 1000,
    autoplaySpeed: 7000,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <SlickArrowLeft currentSlide={undefined} slideCount={undefined} />,
    nextArrow: <SlickArrowRight currentSlide={undefined} slideCount={undefined} />,
};

class BlockVideoSlideShow extends Component {
    departmentsAreaRef = null;

    media = window.matchMedia("(min-width: 992px)");

    componentDidMount() {
        if (this.media.addEventListener) {
            this.media.addEventListener("change", this.onChangeMedia);
        } else {
            // noinspection JSDeprecatedSymbols
            this.media.addListener(this.onChangeMedia);
        }
    }

    componentWillUnmount() {
        departmentsAria.area = null;

        if (this.media.removeEventListener) {
            this.media.removeEventListener("change", this.onChangeMedia);
        } else {
            // noinspection JSDeprecatedSymbols
            this.media.removeListener(this.onChangeMedia);
        }
    }

    onChangeMedia = () => {
        if (this.media.matches) {
            departmentsAria.area = this.departmentsAreaRef;
        }
    };

    setDepartmentsAreaRef = (ref) => {
        this.departmentsAreaRef = ref;

        if (this.media.matches) {
            departmentsAria.area = this.departmentsAreaRef;
        }
    };

    render() {
        const { locale, withDepartments, banners } = this.props;
        const { direction } = languages[locale];

        const blockClasses = classNames("block-slideshow block", {
            "block-slideshow--layout--full": !withDepartments,
            "block-slideshow--layout--with-departments": withDepartments,
        });

        const layoutClasses = classNames("col-12", {
            "col-lg-12": !withDepartments,
            "col-lg-9": withDepartments,
        });

        const slides =
            banners?.length > 0 ? (
                banners.map((slide, index) => {
                    return (
                        <div
                            key={index}
                            className={"block-slideshow__slide" + (slide.link ? " c-pointer" : "")}
                            onClick={
                                slide.link
                                    ? () => {
                                        this.openSlideLink(slide.link);
                                    }
                                    : () => { }
                            }
                        >
                            <ReactPlayer
                                controls url={slide.media_url} playsinline width={"100%"} height={'600px'}
                            // className="block-slideshow__slide-image block-slideshow__slide-image--desktop"
                            />
                            <div className="video-title"><h6><FormattedMessage id={slide.title} /></h6></div>
                        </div>
                    );
                })
            ) : (
                <div className="block-slideshow__slide">
                    <img
                        className="block-slideshow__slide-image block-slideshow__slide-image--desktop"
                        src={"/images/no_banner.jpeg"}
                        alt={"banner-image-desktop"}
                    />
                </div>
            );

        return banners ? (
            <div className={"container"}>
                <h4 className="mt-5">
                    <FormattedMessage id="videoSection.title" defaultMessage="Hup Soon Recommended Recipe" />
                </h4>

                <div className={blockClasses}>
                    <div className="row no-gutters">
                        {withDepartments && <div className="col-3 d-lg-block d-none" ref={this.setDepartmentsAreaRef} />}

                        <div className={layoutClasses}>
                            <div className="block-slideshow__body">
                                <StroykaSlick {...slickSettings}>{slides}</StroykaSlick>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ) : null;
    }
}

BlockVideoSlideShow.propTypes = {
    withDepartments: PropTypes.bool,
    /** current locale */
    locale: PropTypes.string,
};

BlockVideoSlideShow.defaultProps = {
    withDepartments: false,
};

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(BlockVideoSlideShow);
